// src/app/layout/NotificationArea.tsx
import { Bell } from 'lucide-react';

/**
 * The "Notification Area" region called out in the layout spec.
 * Placeholder only: renders a bell button with no unread badge and no
 * dropdown — there is no notifications endpoint/store wired into this
 * handoff yet. Wiring a real feed (badge count, dropdown list) is a
 * follow-up feature, not part of this foundation shell.
 */
export function NotificationArea() {
  return (
    <button
      type="button"
      aria-label="اعلان‌ها"
      className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-[var(--vania-text-secondary,#a6acb8)] transition-colors hover:bg-[var(--vania-surface-2,rgba(255,255,255,0.06))]"
    >
      <Bell size={17} strokeWidth={2.2} />
    </button>
  );
}
